export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-clipboard-notes-e6aae11c5c67fa72f21ad802cfcf2233.svg";